import { DrawingManagerContext } from '../../context/drawing-manager-context.js';
import { ToolbarItem } from '../toolbar-item.js';
import { ProbeIconWrapper } from './probe-icon.js';

import type { ElementType } from 'react';
import type { DrawingManagerContextValue } from '../../context/drawing-manager-context.js';
import type { IToolbarItem, IToolbarItemState, ToolbarItemProps } from '../toolbar-item.js';

interface IOwnState extends IToolbarItemState {}

interface IOwnProps extends ToolbarItemProps {}

export class ProbeToolbarItem extends ToolbarItem<IOwnState, IOwnProps> implements IToolbarItem {
	public static readonly ItemId = 'probe';
	id: string = ProbeToolbarItem.ItemId;
	title = 'Probe';
	keyEventName = 'PROBE';
	defaultKeyBinding = 'p';
	iconElement: ElementType = ProbeIconWrapper;
	includeInHistory = true;
	isExclusive = true;
	// @ts-expect-error
	context: DrawingManagerContextValue | undefined;

	public onActiveStateChanged = () => {
		// Empty on purpose
	};

	public onKeyEvent(): void {
		// Empty on purpose
	}

	public onClick(): void {
		// Empty on purpose
	}
}

ProbeToolbarItem.contextType = DrawingManagerContext;
